import { positionApi } from './position.api';
import type { Position } from '../model/types';
import type { SearchParams, Pagination } from '@/shared/lib';

export async function search(
  searchUrl: string,
  searchParams: SearchParams
): Promise<{ data: Position[]; metadata: Pagination }> {
  const { search, page, amount, sort, filter } = searchParams;
  
  const result = await positionApi.searchPositions({
    search: search || undefined,
    page: page || 1,
    limit: amount || 10,
    sort: sort?.sort || undefined,
    order: sort?.order || undefined,
    active: filter?.active !== undefined ? Boolean(filter.active) : undefined,
    branchId: filter?.branchId ? Number(filter.branchId) : undefined,
    departmentId: filter?.departmentId ? Number(filter.departmentId) : undefined,
  });
  
  return {
    data: result.data,
    metadata: {
      total: result.metadata.total,
      page: result.metadata.page,
      itemsPerPage: result.metadata.itemsPerPage,
      totalPages: result.metadata.totalPages,
      isNextPage: result.metadata.page < result.metadata.totalPages,
      isPreviousPage: result.metadata.page > 1,
    },
  };
}
